<script setup lang="ts">
import { breadcrumb, useBreadcrumbs } from '@/composables/Breadcrumbs';
import { getHomeBreadcrumb } from '@/utils/breadcrumbs';
import { i18n } from '@/utils/i18n';
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps<{
    seiteTitelAktualisieren?: boolean;
}>();

const route = useRoute();
const { breadcrumbItems } = useBreadcrumbs();

const breadcrumbs = computed(() => {
    const kundeParam = route.params.kunde ? { kunde: route.params.kunde } : {};

    const all = [getHomeBreadcrumb(), ...breadcrumbItems.value] as breadcrumb[];

    const items = all.map((c, index, array) => ({
        label: i18n.global.t(c.sprachcode, c.sprachcodeParams || {}),
        // Letztes Item hat keine route (wird nicht verlinkt)
        route: index === array.length - 1 ? undefined : c.routeName ? { name: c.routeName, params: kundeParam, query: c.routeQuery } : undefined,
        icon: c.icon
    }));

    return items;
});

if (props.seiteTitelAktualisieren) {
    const seitenTitel = computed(() => {
        const baseTitle = "myBAV";
        
        if (breadcrumbs.value.length < 2) {
            return baseTitle;
        }

        const last = breadcrumbs.value?.at(-1)?.label;

        return last ? `${baseTitle} | ${last}` : baseTitle;
    });

    watch(seitenTitel, 
        (titel) => { document.title = titel; }, 
        { immediate: true });
}
</script>

<template>
    <Breadcrumb :model="breadcrumbs" class="border-none bg-transparent p-0">
        <template #item="{ item, props }">
            <router-link v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
                <a :href="href" v-bind="props.action" @click="navigate" class="inline-flex items-center gap-1">
                    <div><span v-if="item.icon" :class="[item.icon, 'text-color']" /></div>
                    <span class="text-surface-700 dark:text-surface-0">{{ item.label }}</span>
                </a>
            </router-link>
            <span v-else v-bind="props.action" class="inline-flex items-center gap-1">
                <div><span v-if="item.icon" :class="[item.icon, 'text-color']" /></div>
                <span class="font-semibold text-surface-900 dark:text-surface-0">{{ item.label }}</span>
            </span>
        </template>
    </Breadcrumb>
</template>
